
export default {
  props: {
    kotProp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      kotGroup: {},
      KOT_ITEM: {
        kot_name: ""
      }
    };
  },
  computed: {
    isNew() {
      return !this.kotProp;
    }
  },
  mounted() {
    if (this.isNew) {
      this.kotGroup = this.KOT_ITEM;
    } else {
    }
  },
  methods: {
    handleCreateKotGroup() {},
    handleCancel() {},
    handleModifyKotGroup() {}
  }
};
